import { useEffect } from 'react';
export function useEventListener(_a) {
    var eventName = _a.eventName, handler = _a.handler, _b = _a.element, element = _b === void 0 ? window : _b;
    useEffect(function () {
        var isSupported = element && element.addEventListener;
        if (!isSupported) {
            return;
        }
        var eventListener = function (event) {
            handler(event);
        };
        element.addEventListener(eventName, eventListener);
        return function () {
            element.removeEventListener(eventName, eventListener);
        };
    }, [eventName, handler, element]);
}
//# sourceMappingURL=use-event-listener.js.map